
import './App.css';
import { Routes, Route } from "react-router-dom";
import About from "./Components/About";
import Contact from "./Components/Contact";
import Home from "./Components/Home";
import Projects from "./Components/Projects";
import Skills from "./Components/Skills";
import  { ThemeProvider, createGlobalStyle } from "styled-components";
import theme from "./theme";
import ScrollToTop from "react-scroll-to-top";
import Navbar from './Components/Navbar';



const GlobalStyles = createGlobalStyle`
    body {
      background-color: ${(props) => props.theme.bg.main}
    } 
`;


function App() {

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <ScrollToTop smooth />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/skills" element={<Skills />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
